import { addNotification } from '#notifications/notificationsSlice';
import { useDispatch } from '#redux';

/** Un aviso breve de texto (el «toast» de abajo). */
export function useAvisar(): (message: string) => void {
  const dispatch = useDispatch();
  return message =>
    void dispatch(
      addNotification({ notification: { type: 'message', message } }),
    );
}
